import React from 'react';
import type { CartItem as CartItemType } from '../types';
import './CartItem.css';

interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (itemId: number, quantity: number) => void;
  onRemove: (itemId: number) => void;
  onProductClick?: (productId: number) => void;
}

export const CartItem: React.FC<CartItemProps> = ({
  item,
  onUpdateQuantity,
  onRemove,
  onProductClick,
}) => {
  const handleDecrease = () => {
    if (item.quantity > 1) {
      onUpdateQuantity(item.id, item.quantity - 1);
    }
  };

  const handleIncrease = () => {
    onUpdateQuantity(item.id, item.quantity + 1);
  };

  const handleRemove = () => {
    onRemove(item.id);
  };

  const handleProductClick = () => {
    if (onProductClick) {
      onProductClick(item.product_id);
    }
  };

  const formatPrice = (price: number) => {
    return `${price.toFixed(0)} ₽`;
  };

  return (
    <div className="cart-item">
      <div className="cart-item-image" onClick={handleProductClick}>
        <img
          src={item.image_url || 'https://via.placeholder.com/80x80?text=No+Image'}
          alt={item.product_name}
          onError={(e) => {
            e.currentTarget.src = 'https://via.placeholder.com/80x80?text=No+Image';
          }}
        />
      </div>

      <div className="cart-item-content">
        <div className="cart-item-info">
          <h3 className="cart-item-name" onClick={handleProductClick}>{item.product_name}</h3>
          <p className="cart-item-price">{formatPrice(item.price)}</p>
        </div>

        <div className="cart-item-actions">
          <div className="quantity-controls">
            <button
              className="quantity-btn"
              onClick={handleDecrease}
              disabled={item.quantity <= 1}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 7H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>

            <span className="quantity-value">{item.quantity}</span>

            <button
              className="quantity-btn"
              onClick={handleIncrease}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 2V12M2 7H12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          <div className="cart-item-subtotal">
            <p className="subtotal-label">Итого:</p>
            <p className="subtotal-value">{formatPrice(item.subtotal)}</p>
          </div>

          <button className="remove-btn" onClick={handleRemove}>
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path d="M4 5H16M8 8V14M12 8V14M5 5L6 16C6 16.5304 6.21071 17.0391 6.58579 17.4142C6.96086 17.7893 7.46957 18 8 18H12C12.5304 18 13.0391 17.7893 13.4142 17.4142C13.7893 17.0391 14 16.5304 14 16L15 5M7 5V3C7 2.73478 7.10536 2.48043 7.29289 2.29289C7.48043 2.10536 7.73478 2 8 2H12C12.2652 2 12.5196 2.10536 12.7071 2.29289C12.8946 2.48043 13 2.73478 13 3V5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
